import React from 'react';
import { motion } from 'framer-motion';
interface StatementProps {
  text: string;
  highlight: string;
  index: number;
}
function Statement({
  text,
  highlight,
  index
}: StatementProps) {
  const parts = text.split(highlight);
  return <motion.div className="py-10 md:py-14" initial={{
    opacity: 0,
    x: -40
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true,
    amount: 0.5
  }} transition={{
    delay: index * 0.4,
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-89">
      <p className="font-heading font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white leading-tight" data-id="element-90">
        {parts[0]}
        <span className="text-ultra-gold" data-id="element-91">{highlight}</span>
        {parts[1]}
      </p>
    </motion.div>;
}
function Divider() {
  return <div className="h-px w-full" style={{
    background: 'linear-gradient(90deg, transparent 0%, #8B5CF6 50%, transparent 100%)',
    opacity: 0.25
  }} aria-hidden="true" data-id="element-92" />;
}
export function StakesSection() {
  return <section className="relative min-h-screen w-full flex items-center" data-id="element-93">
      {/* Background gradient */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 70% 40% at 50% 0%, rgba(139,92,246,0.08) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-94" />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-12 py-20" data-id="element-95">
        {/* Section label */}
        <motion.p className="font-heading text-xs md:text-sm uppercase tracking-[0.3em] text-ultra-gold mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          The Stakes
        </motion.p>

        <Statement text="Online casinos lose €1.2B yearly to player disengagement" highlight="€1.2B" index={0} data-id="element-97" />
        <Divider data-id="element-98" />
        <Statement text="Generic experiences drive 73% of high-value players away" highlight="73%" index={1} data-id="element-99" />
        <Divider data-id="element-100" />
        <Statement text="Traditional analytics react — they never predict" highlight="never predict" index={2} data-id="element-101" />
      </div>
    </section>;
}